import instObj from '@/backend/axios-instances'

const resource = "images/project/"
const instance = instObj.baseInstance

export default {
  post(projectId, proposalId, data, parameters) {
    return instance.post(
      `${resource}${projectId}/proposal/${proposalId}`,
      data,
      { params: parameters }
    )
  }
}
